import React from 'react';
import { CheckCircle, Mail, X } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';

const ProfileSubmittedModal = ({ isOpen, onClose }) => {
  const { isDark } = useTheme();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ background: 'rgba(8,11,20,.7)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', padding: 20 }}
    >
      <div
        className="relative w-full max-w-md overflow-hidden animate-fade-in"
        style={{ background: '#12162A', border: '1px solid rgba(255,255,255,.12)', borderRadius: 22, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 40px 90px -30px rgba(0,0,0,.85)', fontFamily: "'Work Sans', sans-serif" }}
      >
        {/* Success Header */}
        <div
          className="px-6 py-8 text-center relative"
          style={{ background: 'linear-gradient(120deg,#15803D,#0F5132)', borderTopLeftRadius: 22, borderTopRightRadius: 22, overflow: 'hidden' }}
        >
          <img
            src="/assets/website/symbol-white.svg"
            alt=""
            aria-hidden="true"
            style={{ position: 'absolute', right: -28, top: -28, width: 150, height: 150, opacity: 0.06, animation: 'szspin 80s linear infinite', pointerEvents: 'none' }}
          />
          <div className="flex items-center justify-center mx-auto mb-4 relative" style={{ width: 80, height: 80, borderRadius: '9999px', background: 'rgba(255,255,255,.18)' }}>
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
          <h3 className="text-2xl font-bold text-white relative" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Profile Submitted!
          </h3>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="text-center">
            <p className="text-lg mb-4" style={{ color: '#fff' }}>
              Your profile has been submitted for approval.
            </p>
          </div>

          {/* Email Notification Info */}
          <div className="p-4" style={{ borderRadius: 12, background: 'rgba(40,192,208,.08)', border: '1px solid rgba(40,192,208,.28)' }}>
            <div className="flex gap-3">
              <Mail className="flex-shrink-0 mt-0.5" style={{ color: '#28C0D0' }} size={20} />
              <div>
                <h4 className="font-semibold mb-1" style={{ color: '#fff' }}>
                  What happens next?
                </h4>
                <ul className="text-sm space-y-2" style={{ color: 'rgba(255,255,255,.6)' }}>
                  <li>✓ Our admin team will review your profile</li>
                  <li>✓ You'll receive an email when your profile is approved</li>
                  <li>✓ Once approved, you'll have full access to all features</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="p-3 text-center" style={{ borderRadius: 12, background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.1)' }}>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,.6)' }}>
              Approval usually takes <strong style={{ color: '#fff' }}>less than 24 hours</strong>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <Button
            onClick={onClose}
            className="w-full font-semibold py-3 hover:opacity-90"
            style={{ background: '#28C0D0', color: '#06121A' }}
          >
            Continue to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileSubmittedModal;
